import React, { useEffect, useState, useRef } from 'react';

import axios from 'axios';
import moment from 'moment';
import ModalLoad from '../../../components/modal/ModalLoad.js';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';

function StandingAlarm(props) {
    const formremarkRef = useRef(null)

    const [enable_ackall, setEnable_ackall] = useState(false);
    const [modal_remark, setModal_remark] = useState(false);
    const [remark_item, setRemark_item] = useState({
        Event_ID: '',
        Event_DateTimeStamp_Active: '',
        Event_Class: '',
        Event_Source: '',
        Event_Tagname: '',
        Event_Category: '',
        Remark: '',
    })

    const [data_alarmevent_standing, setData_alarmevent_standing] = useState([])
    const [remark_display_id, setRemark_display_id] = useState('')

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        return () => {
            setData_alarmevent_standing([])
        };
    }, []);

    useEffect(() => {
        if (props.data_alarmevent_standing !== undefined && props.data_alarmevent_standing !== null) {
            setData_alarmevent_standing(props.data_alarmevent_standing)
            if (props.data_alarmevent_standing.length > 0) {
                const found = props.data_alarmevent_standing.find((element) => element.Ack_Req === true && element.Ack_Status === false);
                if (found !== undefined) {
                    setEnable_ackall(true)
                } else {
                    setEnable_ackall(false)
                }
            } else {
                setEnable_ackall(false)
            }
        } else {
            setEnable_ackall(false)
        }
    }, [props.data_alarmevent_standing]);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(code) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
        if (code.mode === "single") {
            api_ack_single(code.event_id)
        } else {
            api_ack_all()
        }
    }

    async function api_saveremark() {
        var formelement = formremarkRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('event_id', remark_item.Event_ID)
            formData.append('remark_text', remark_item.Remark)

            setmodal_load({ enable: true, message: "Saving alarm event remark." })
            await sleep(500)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/alarmevent/remark", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_remark(false)
                    setRemark_item({
                        Event_ID: '',
                        Event_DateTimeStamp_Active: '',
                        Event_Class: '',
                        Event_Source: '',
                        Event_Tagname: '',
                        Event_Category: '',
                        Remark: '',
                    })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your alarm event remark has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        });
                    }
                    if (response.data.remark !== undefined) {
                        const nextalarm = data_alarmevent_standing.map(alarm => {
                            if (alarm.Event_ID === response.data.event_id) {
                                return {
                                    ...alarm,
                                    Remark: response.data.remark,
                                };
                            } else {
                                return alarm;
                            }
                        });
                        setData_alarmevent_standing(nextalarm)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_remark(false)
                    setRemark_item({
                        Event_ID: '',
                        Event_DateTimeStamp_Active: '',
                        Event_Class: '',
                        Event_Source: '',
                        Event_Tagname: '',
                        Event_Category: '',
                        Remark: '',
                    })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    });
                });
        }
    }

    async function api_ack_single(event_id) {
        const formData = new FormData();
        formData.append('event_id', event_id)
        formData.append('username', props.permitdata.username)

        setmodal_load({ enable: true, message: "Saving alarm event ack." })
        await sleep(500)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/alarmevent/acksingle", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your alarm event ack has been saved to database.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.event_id !== undefined) {
                    const nextalarm = data_alarmevent_standing.map(alarm => {
                        if (alarm.Event_ID === response.data.event_id) {
                            return {
                                ...alarm,
                                Ack_Status: response.data.ack_status,
                                Ack_By: response.data.ack_by,
                                Ack_Time: response.data.ack_time,
                            };
                        } else {
                            return alarm;
                        }
                    });
                    setData_alarmevent_standing(nextalarm)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_ack_all() {
        const formData = new FormData();
        formData.append('username', props.permitdata.username)

        setmodal_load({ enable: true, message: "Saving alarm event ack." })
        await sleep(500)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/alarmevent/ackall", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your alarm event ack has been saved to database.",
                        enable: true
                    });
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.ack_status !== undefined) {
                    const nextalarm = data_alarmevent_standing.map(alarm => {
                        if (alarm.Ack_Req === true && alarm.Ack_Status === false && alarm.Event_Class !== "Info" && alarm.Event_Class !== "System") {
                            return {
                                ...alarm,
                                Ack_Status: response.data.ack_status,
                                Ack_By: response.data.ack_by,
                                Ack_Time: response.data.ack_time,
                            };
                        } else {
                            return alarm;
                        }
                    });
                    setData_alarmevent_standing(nextalarm)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    function alarm_record_bg_color(data) {
        if (data.Event_Class === "Critical" || data.Event_Class === "Major") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-red"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-red"
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-red"
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Minor") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-orange"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-orange"
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-orange"
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Warning") {
            if (data.Ack_Req) {
                if (data.Ack_Status) {
                    if (data.Event_Status) {
                        return "alarmevent-bg-yellowe"
                    } else {
                        return ""
                    }
                } else {
                    return "alarmevent-blink-bg-yellow "
                }
            } else {
                if (data.Event_Status) {
                    return "alarmevent-blink-bg-yellow "
                } else {
                    return ""
                }
            }
        } else if (data.Event_Class === "Info") {
            return ""
        } else if (data.Event_Class === "System") {
            return ""
        }
    }

    function count_isrequired() {
        const index = data_alarmevent_standing.findIndex((element) => element.Ack_Req === true)
        if (index > -1) {
            return true
        }
        return false
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-alert-rhombus-outline color-orange"></i> Realtime Alarm</h4>
                                    <p className="mb-1">Display all standing alarm.</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {props.server_update !== "-" ? moment(new Date(props.server_update)).format("YYYY-MM-DD HH:mm:ss") : "Unknown"}</h6>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                        </div>
                    </div>

                    <div className="row mt-2 mb-1 mb-md-4">
                        <div className='d-flex justify-content-between flex-wrap mb-2'>
                            <div className='d-block'>
                                <div className='py-0 my-0'><h5 className='py-0 mb-0'>Realtime Alarm List ({data_alarmevent_standing.length} Events)</h5></div>
                                <div className="d-block mt-2">
                                    <h6 className='py-0 my-0 '>Banner Color Definition</h6>
                                    <div className='d-flex gap-3 flex-wrap mt-0'>
                                        <p className='mb-0 mt-0'><i className='mdi mdi-rectangle alarmevent-text-red'></i>Critical, Major</p>
                                        <p className='mb-0 mt-0'><i className='mdi mdi-rectangle alarmevent-text-orange'></i>Minor</p>
                                        <p className='mb-0 mt-0'><i className='mdi mdi-rectangle text-yellow'></i>Warning</p>
                                    </div>
                                </div>
                            </div>
                            {
                                props.permitdata !== undefined ?
                                    props.permitdata.user_role !== "Viewer" ?
                                        <button className={"btn btn-warning btn-sm mb-0 " + (enable_ackall === true ? "" : "d-none")} onClick={() => {
                                            setModal_popup({
                                                modaltype: 'modal-confirm',
                                                headers: 'Confirmation',
                                                message: "Please click on confirm button to acknownledge all event.",
                                                enable: true,
                                                confirmcode: {
                                                    mode: "all",

                                                }
                                            });
                                        }}><i className="fas fa-bell-slash"></i> Acknownledge All</button>
                                        :
                                        null
                                    : null
                            }
                        </div>



                        <div className="table-responsive">
                            <table className="table table-bordered table-alarm text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>Event Class</th>
                                        <th>Event DateTime Active</th>
                                        <th className={'' + (count_isrequired() === true ? "" : " d-none")}>Event DateTime InActive</th>
                                        <th>Event Device</th>
                                        {/* <th>Event Tags</th> */}
                                        <th>Category</th>
                                        <th>Status</th>
                                        <th>Acknowledge Status</th>
                                        <th>Message</th>
                                        {
                                            props.permitdata !== undefined ?
                                                props.permitdata.user_role !== "Viewer" ?
                                                    <th width={"40px"}>Action</th>
                                                    :
                                                    null
                                                :
                                                null
                                        }
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        data_alarmevent_standing.map((data, index) => (
                                            <tr key={data.Event_ID} className={alarm_record_bg_color(data)}>
                                                <td className='font-sarabun'>
                                                    <div className='alarm-icon'>
                                                        <i className={"fas fa-bell me-2 "
                                                            + (data.Event_Class === "Critical" || data.Event_Class === "Major" ?
                                                                "text-danger"
                                                                : data.Event_Class === "Minor" ?
                                                                    "text-warning"
                                                                    : data.Event_Class === "Warning" ?
                                                                        "text-yellow"
                                                                        : data.Event_Class === "Info" || data.Event_Class === "Hints" ?
                                                                            "text-info"
                                                                            : "rows-icon"
                                                            )}></i>
                                                    </div>
                                                    {data.Event_Class}
                                                </td>
                                                <td className='font-sarabun'>
                                                    {data.Event_DateTimeStamp_Active}
                                                </td>
                                                {
                                                    data.Event_Class === "Info" || data.Device_Type === "Server" ?
                                                        <td className={'font-sarabun ' + (count_isrequired() === true ? "" : " d-none")}>-</td>
                                                        :
                                                        <td className={'font-sarabun ' + (count_isrequired() === true ? "" : " d-none")}>{data.Event_DateTimeStamp_InActive}</td>
                                                }
                                                <td className='font-sarabun'>{data.Event_Source}</td>
                                                {/* <td className='font-sarabun'>{data.Event_Tagname}</td> */}
                                                <td className='font-sarabun'>{data.Event_Category}</td>
                                                <td className='font-sarabun'>
                                                    {
                                                        data.Event_Class !== "Info" ?
                                                            data.Event_Status ?
                                                                "Active"
                                                                :
                                                                "InActive"
                                                            :
                                                            "-"
                                                    }
                                                </td>
                                                <td className='font-sarabun'>
                                                    {
                                                        data.Ack_Req ?
                                                            data.Ack_Status ?
                                                                "Ack. Pending"
                                                                :
                                                                <>
                                                                    <p className='mb-1'>Acked.-{data.Ack_by}</p>
                                                                    <p className='mb-1'>{data.Ack_Time}</p>
                                                                </>
                                                            :
                                                            "Not Required"
                                                    }
                                                </td>
                                                <td className='font-sarabun'>
                                                    <i className={'fas fa-info-circle pe-2 text-blue remark-flags ' + (data.Remark === "" ? "d-none" : "")} onClick={() => { setRemark_display_id(remark_display_id === "" ? data.Event_ID : "") }}></i>
                                                    {data.Message_Str}
                                                    <div className={'mt-1 mb-0 ' + (remark_display_id === data.Event_ID && data.Remark !== "" ? "" : "d-none")}>
                                                        <b>Remark:</b>
                                                        <p className='mt-1 mb-1'>{data.Remark}</p>
                                                    </div>
                                                </td>
                                                {
                                                    props.permitdata !== undefined ?
                                                        props.permitdata.user_role !== "Viewer" ?
                                                            <td>
                                                                {
                                                                    data.Ack_Req === true && data.Ack_Status === false ?
                                                                        <i className="fas fa-bell-slash me-2 cursor-pointers events-action" onClick={() => {
                                                                            setModal_popup({
                                                                                modaltype: 'modal-confirm',
                                                                                headers: 'Confirmation',
                                                                                message: "Please click on confirm button to acknownledge this event.",
                                                                                enable: true,
                                                                                confirmcode: {
                                                                                    mode: "single",
                                                                                    event_id: data.Event_ID
                                                                                }
                                                                            });
                                                                        }}></i>
                                                                        :
                                                                        null
                                                                }
                                                                <i className='fas fa-pen cursor-pointers events-action' onClick={() => { setRemark_item(data); setModal_remark(true) }}></i>
                                                            </td>
                                                            :
                                                            null
                                                        : null
                                                }
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {
                        modal_remark ?
                            <div className='modal-overlay'>
                                <div className="modal d-block" >
                                    <div className="modal-dialog modal-lg modal-dialog-centered">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title"><i className="fas fa-pen"></i> Event Remarker</h4>
                                                <i className="fe-x modal-close" onClick={() => { setModal_remark(false) }}></i>
                                            </div>
                                            <div className="modal-body">
                                                <form ref={formremarkRef} action="" method="POST" encType="multipart/form-data">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="event_id">Event ID</label>
                                                                <input type="text" className="form-control" name="event_id" value={remark_item.Event_ID} disabled />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="tag_name">Tag Name</label>
                                                                <input type="text" className="form-control" name="tag_name" value={remark_item.Event_Tagname} disabled />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="event_class">Event Class</label>
                                                                <input type="text" className="form-control" name="event_class" value={remark_item.Event_Class} disabled />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="form-group">
                                                                <label htmlFor="category">Event Category</label>
                                                                <input type="text" className="form-control" name="category" value={remark_item.Event_Category} disabled />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label htmlFor="remark">Remark Text</label>
                                                                <textarea type="text" className="form-control" name="remark" rows={3} value={remark_item.Remark} onChange={(e) => {
                                                                    setRemark_item({
                                                                        ...remark_item,
                                                                        Remark: e.target.value
                                                                    })
                                                                }} required />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                            <div className="modal-footer">
                                                <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_remark(false) }}><i className="fe-x"></i> Cancel</button>
                                                <button className="btn btn-warning btn-sm" onClick={() => { api_saveremark() }}><i className="fe-save"></i> Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                    }

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default StandingAlarm